import SampleDetailAdditionalInfo from './OilSampleDetailAdditionalInformation.vue';
import SampleDetailBasicInfo from './OilSampleDetailBasicInformation.vue';
import SampleDetailBillingInfo from './OilSampleDetailBillingInformation.vue';
import SampleDetailHeader from './OilSampleDetailHeader.vue';
import SampleDetailPrimaryResults from './OilSampleDetailPrimaryResults.vue';
import SampleDetailSecondaryResults from './OilSampleDetailSecondaryResults.vue';

export default {
  SampleDetailAdditionalInfo,
  SampleDetailBasicInfo,
  SampleDetailBillingInfo,
  SampleDetailHeader,
  SampleDetailPrimaryResults,
  SampleDetailSecondaryResults
};
